export default __webpack_public_path__ + "static/media/ftj-3.a9cee79a.jpeg";